var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x90\x8D\xE7\xA7\xB0=\xE6\x88\xAA\xE9\x9D\xA2, \xE5\xAF\xBC\xE8\x88\xAA=\xE7\xBB\x93\xE6\x9E\x84, \xE8\x8B\xB1\xE6\x96\x87\xE5\x90\x8D=Default",
    clipPath: "url(#clip0_639_2510)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1.46484 1.45496V0.954956C1.1887 0.954956 0.964844 1.17881 0.964844 1.45496H1.46484ZM7.53309 1.45496H8.03309C8.03309 1.17881 7.80924 0.954956 7.53309 0.954956V1.45496ZM1.46484 14.545H0.964844C0.964844 14.8212 1.1887 15.045 1.46484 15.045V14.545ZM7.53309 14.545V15.045C7.80924 15.045 8.03309 14.8212 8.03309 14.545H7.53309ZM7.53309 10.8359V10.3359C7.25695 10.3359 7.03309 10.5597 7.03309 10.8359H7.53309ZM14.5353 10.8359V11.3359C14.8114 11.3359 15.0353 11.112 15.0353 10.8359H14.5353ZM14.5353 5.16411H15.0353C15.0353 4.88797 14.8114 4.66411 14.5353 4.66411V5.16411ZM7.53309 5.16411H7.03309C7.03309 5.44025 7.25695 5.66411 7.53309 5.66411V5.16411ZM1.46484 1.95496H7.53309V0.954956H1.46484V1.95496ZM1.96484 14.545V1.45496H0.964844V14.545H1.96484ZM7.53309 14.045H1.46484V15.045H7.53309V14.045ZM7.03309 10.8359V14.545H8.03309V10.8359H7.03309ZM14.5353 10.3359H7.53309V11.3359H14.5353V10.3359ZM14.0353 5.16411V10.8359H15.0353V5.16411H14.0353ZM7.53309 5.66411H14.5353V4.66411H7.53309V5.66411ZM7.03309 1.45496V5.16411H8.03309V1.45496H7.03309Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 95",
    d: "M1.46484 5.02148L4.79002 1.69631",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 96",
    d: "M1.46484 8.34668L7.51511 2.29642",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 97",
    d: "M1.46484 11.6718L7.78257 5.35402",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 98",
    d: "M2.15283 14.3091L11.1483 5.31358",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 99",
    d: "M9.1748 10.6123L14.1904 5.59668",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 100",
    d: "M12.3586 10.6896L14.5353 8.51296",
    stroke: "#222627",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 99_2",
    d: "M5.39355 14.4873L7.40921 12.4716",
    stroke: "#222627",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_2510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.4637077543b768d36980ec34c48dc4e0.svg";
export { ForwardRef as ReactComponent };